/* =============================================================
   Sensovyu Scroll Reveal
   Loaded by snippets/sou-reveal.liquid. See sou-reveal.css for
   the markup contract.
   ============================================================= */
(function () {
  'use strict';

  // The snippet is rendered per section, so this file can appear on
  // the page more than once. Only the first copy does any work.
  if (window.souReveal) return;

  var observer = null;

  function scan(scope) {
    if (!observer) return;
    (scope || document).querySelectorAll('.sou-fade-in:not(.visible)').forEach(function (el) {
      observer.observe(el);
    });
  }

  function start() {
    if (!window.IntersectionObserver) {
      // Nothing can reveal these, so un-arm and leave everything visible.
      document.documentElement.classList.remove('sou-js-fade');
      return;
    }

    observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        var delay = parseInt(el.getAttribute('data-fade-delay') || '0', 10);
        setTimeout(function () { el.classList.add('visible'); }, delay);
        observer.unobserve(el);
      });
    }, {
      // A ratio threshold can never be met by an element taller than
      // the viewport divided by that ratio, which would leave a long
      // section permanently hidden. An edge offset works at any height.
      threshold: 0,
      rootMargin: '0px 0px -80px 0px'
    });

    scan(document);
  }

  window.souReveal = { scan: scan };

  // Loaded with defer, so the document is already parsed. The check is
  // for safety if it is ever included without defer.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  // The theme editor re-renders one section without a page load.
  document.addEventListener('shopify:section:load', function (e) {
    scan(e.target);
  });
})();
